import { get } from 'lodash';
import { extractButton } from '../../utils/elements';
export const getButton = ({ region, css, isRtl = false, experiments = {}, mixData, }) => {
    const buttonStyles = get(region, 'data.styles.main') || {};
    const defaultStyles = css['so-global-b1-mix'];
    const maxWidth = get(defaultStyles, 'maxWidth') || '300px';
    const minWidth = get(defaultStyles, 'minWidth') || '140px';
    const minCalculatedColumnWidth = Math.min.apply(null, [...mixData.data.layout.rows[0].columns].map((col) => col.width));
    const button = extractButton({
        customStyles: buttonStyles,
        defaultStyles,
        experiments,
        isRtl,
        region,
        minCalculatedColumnWidth: minCalculatedColumnWidth,
    });
    return {
        button,
        regionId: region.regionId,
        type: 'button',
        minWidth,
        maxWidth,
    };
};
//# sourceMappingURL=get-button.js.map